import ManagersGateway from './ManagersGateway'
import ManagersListModel from './ManagersListModel'
import ManagerModel from './ManagerModel'

export default class ManagersService {
  constructor (managersGateway) {
    this.ManagersGateway = managersGateway || new ManagersGateway()

    this.assignTag = this.assignTag.bind(this)
    this.getManagers = this.getManagers.bind(this)
    this.getManagersList = this.getManagersList.bind(this)
    this.getManagersChildrenById = this.getManagersChildrenById.bind(this)
    this.managersExportExcel = this.managersExportExcel.bind(this)
    this.uploadManagers = this.uploadManagers.bind(this)
    this.removeTag = this.removeTag.bind(this)
    this.assignEmployee = this.assignEmployee.bind(this)
    this.assignEmployees = this.assignEmployees.bind(this)
    this.removeEmployee = this.removeEmployee.bind(this)
    this.removeEmployees = this.removeEmployees.bind(this)
    this.moveEmployee = this.moveEmployee.bind(this)
    this.moveEmployees = this.moveEmployees.bind(this)
    this.update = this.update.bind(this)
    this.add = this.add.bind(this)
    this.delete = this.delete.bind(this)
    this.move = this.move.bind(this)
    this.managersRemoveFromTag = this.managersRemoveFromTag.bind(this)
    this.uploadManagersAppend = this.uploadManagersAppend.bind(this)
  }

  managersRemoveFromTag (query) {
    return this.ManagersGateway
    .managersRemoveFromTag(query)
    .then((response) => response)
  }

  move (query) {
    return this.ManagersGateway
    .move(query)
    .then((response) => response)
  }

  delete (query) {
    return this.ManagersGateway
    .delete(query)
    .then((response) => response)
  }

  add (query) {
    return this.ManagersGateway
    .add(query)
    .then((response) => response)
  }

  update (query) {
    return this.ManagersGateway
    .update(query)
    .then(response => response)
  }

  moveEmployee (query) {
    return this.ManagersGateway
    .moveEmployee(query)
    .then(response => response)
  }

  moveEmployees (query) {
    return this.ManagersGateway
    .moveEmployees(query)
    .then(response => response)
  }

  removeEmployee (query) {
    return this.ManagersGateway
    .removeEmployee(query)
    .then(response => response)
  }

  removeEmployees (query) {
    return this.ManagersGateway
    .removeEmployees(query)
    .then(response => response)
  }

  assignEmployee (query) {
    return this.ManagersGateway
    .assignEmployee(query)
    .then(response => response)
  }

  assignEmployees (query) {
    return this.ManagersGateway
    .assignEmployees(query)
    .then(response => response)
  }

  assignTag (query) {
    return this.ManagersGateway
    .assignTag(query)
    .then(response => response)
  }

  removeTag (query) {
    return this.ManagersGateway
    .removeTag(query)
    .then(response => response)
  }

  getManagers () {
    return this.ManagersGateway
      .getManagers()
      .then(response => {
        return new ManagersListModel(response)
      })
  }

  getManagersList () {
    return this.ManagersGateway
      .getManagersList()
      .then(response => {
        return response.map(item => new ManagerModel(item))
      })
  }

  getManagersChildrenById (params) {
    return this.ManagersGateway
    .getManagersChildrenById(params)
    .then(response => new ManagersListModel(response))
  }

  managersExportExcel () {
    return this.ManagersGateway
    .managersExportExcel()
    .then(response => response)
  }

  uploadManagers (query) {
    return this.ManagersGateway
      .uploadManagers(query)
      .then(response => response)
  }

  uploadManagersAppend (query) {
    return this.ManagersGateway
      .uploadManagersAppend(query)
      .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/managers/ManagersService.js